// extracted by mini-css-extract-plugin
module.exports =  {"tc-breadcrumb":"Breadcrumbs-module__tc-breadcrumb___hqvOo","loading":"Breadcrumbs-module__loading___S9QK_"};